import React, { useState, useEffect } from 'react';

import { SingleText, SingleSelect, SingleRedio } from '../../Res/BaseInput';
import { RespCustomerContract_PaymentTerms } from '../../../../item/ItemCustomerContract';
import { Space } from '../../Res/BaseButton';
import { getItemsInfo } from '../../../../item/ItemTools';

export function ItemPaymentTerms({ item, action, isEdit = true }) {
  const [paymentTerms, setPaymentTerms] = useState("")
  const [paymentDate1, setPaymentDate1] = useState("0")
  const [paymentDate2, setPaymentDate2] = useState("0")
  const [paymentDate3, setPaymentDate3] = useState("0")
  const [paymentAnnualLeave, setPaymentAnnualLeave] = useState("1")
  const [paymentCycleDateStart, setPaymentCycleDateStart] = useState("0")
  const [paymentCycleDateEnd, setPaymentCycleDateEnd] = useState("0")
  const [paymentMethod, setPaymentMethod] = useState("0")
  const [paymentTax, setPaymentTax] = useState("1")

  useEffect(() => {
    //console.log(item)
    //console.log(paymentTerms)
    if (item !== undefined && paymentTerms !== item) {
      setPaymentTerms(item)
      setPaymentDate1(item.paymentDate1)
      setPaymentDate2(item.paymentDate2)
      setPaymentDate3(item.paymentDate3)
      setPaymentAnnualLeave(item.paymentAnnualLeave)
      setPaymentCycleDateStart(item.paymentCycleDateStart)
      setPaymentCycleDateEnd(item.paymentCycleDateEnd)
      setPaymentMethod(item.paymentMethod)
      setPaymentTax(item.paymentTax)
    }
  }, [item])

  useEffect(() => {
    if (action !== undefined) {
      //console.log(paymentDate1)
      var mRespCustomerContract_PaymentTerms = new RespCustomerContract_PaymentTerms({
        paymentDate1,
        paymentDate2,
        paymentDate3,
        paymentAnnualLeave,
        paymentCycleDateStart,
        paymentCycleDateEnd,
        paymentMethod,
        paymentTax
      })
      //console.log(mRespCustomerContract_PaymentTerms)
      action(mRespCustomerContract_PaymentTerms)
    }
  }, [paymentDate1, paymentDate2, paymentDate3, paymentAnnualLeave, paymentCycleDateStart,
    paymentCycleDateEnd, paymentMethod, paymentTax, action])

  const dateItems = [
    { val: "0", name: "月底" },
    { val: "1", name: "1日" },
    { val: "2", name: "2日" },
    { val: "3", name: "3日" },
    { val: "4", name: "4日" },
    { val: "5", name: "5日" },
    { val: "6", name: "6日" },
    { val: "7", name: "7日" },
    { val: "8", name: "8日" },
    { val: "9", name: "9日" },
    { val: "10", name: "10日" },
    { val: "11", name: "11日" },
    { val: "12", name: "12日" },
    { val: "13", name: "13日" },
    { val: "14", name: "14日" },
    { val: "15", name: "15日" },
    { val: "16", name: "16日" },
    { val: "17", name: "17日" },
    { val: "18", name: "18日" },
    { val: "19", name: "19日" },
    { val: "20", name: "20日" },
    { val: "21", name: "21日" },
    { val: "22", name: "22日" },
    { val: "23", name: "23日" },
    { val: "24", name: "24日" },
    { val: "25", name: "25日" },
    { val: "26", name: "26日" },
    { val: "27", name: "27日" },
    { val: "28", name: "28日" },
  ]


  const isItems = [
    { "val": 1, "name": "是" },
    { "val": 0, "name": "否" },
  ]

  const paymentMethodItems = [
    { val: "1", name: "匯款" },
    { val: "2", name: "支票" },
  ]

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>付款條件</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={""} val={"請款時數以各職缺之派遣費用項目為請領依據。"} size={6} />
        </div>
      </div>
      <Space />
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleSelect title={"每月 之前核定請款檔"}
              val={paymentDate1}
              attr={dateItems}
              action={setPaymentDate1}
              hasBlank={true}
            />
            : <SingleText title={"每月 之前核定請款檔"} val={getItemsInfo({ items: dateItems, val: paymentDate1 })} />
          }
          {isEdit ?
            <SingleSelect title={"每月 之前雙方確認無誤並由乙方開立發票"}
              val={paymentDate2}
              attr={dateItems}
              action={setPaymentDate2}
              hasBlank={true}
            />
            : <SingleText title={"每月 之前雙方確認無誤並由乙方開立發票"} val={getItemsInfo({ items: dateItems, val: paymentDate2 })} />
          }
          {isEdit ?
            <SingleSelect title={"甲方於每月 之前匯款"}
              val={paymentDate3}
              attr={dateItems}
              action={setPaymentDate3}
              hasBlank={true}
            />
            : <SingleText title={"甲方於每月 之前匯款"} val={getItemsInfo({ items: dateItems, val: paymentDate3 })} />
          }
          {isEdit ?
            <SingleRedio title={"廠商是否支付特休給付"}
              arr={isItems}
              val={paymentAnnualLeave ? 1 : 0}
              action={setPaymentAnnualLeave}
              size={3}
            />
            : <SingleText title={"廠商是否支付特休給付"} val={(paymentAnnualLeave+"" === "1") ? "是" : "否"} />
          }
        </div>
      </div>
      <Space />
      <Space />
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleSelect title={"請款結算週期開始於每月"}
              val={paymentCycleDateStart}
              attr={dateItems}
              action={setPaymentCycleDateStart}
              hasBlank={true}
            />
            : <SingleText title={"請款結算週期開始於每月"} val={getItemsInfo({ items: dateItems, val: paymentCycleDateStart })} />
          }
          {isEdit ?
            <SingleSelect title={"請款結算週期結束於每月"}
              val={paymentCycleDateEnd}
              attr={dateItems}
              action={setPaymentCycleDateEnd}
              hasBlank={true}
            />
            : <SingleText title={"請款結算週期結束於每月"} val={getItemsInfo({ items: dateItems, val: paymentCycleDateEnd })} />
          }
          {isEdit ?
            <SingleSelect title={"付款方式"}
              val={paymentMethod}
              attr={paymentMethodItems}
              action={setPaymentMethod}
              hasBlank={true}
            />
            : <SingleText title={"付款方式"} val={getItemsInfo({ items: paymentMethodItems, val: paymentMethod })} />
          }
          {isEdit ?
            <SingleRedio title={"報價是否含5%營業稅"}
              arr={isItems}
              val={paymentTax ? 1 : 0}
              action={setPaymentTax}
              size={3}
            />
            : <SingleText title={"報價是否含5%營業稅"} val={paymentTax === 1 ? "是" : "否"} />
          }
        </div>
      </div>
    </>
  )
}